import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { MaterialIcon } from '../../../../components/MaterialIcon';
import { Dialog } from '../../../../components/Dialog';
import { DialogHeader } from '../../../../components/DialogHeader';
import { DialogBody } from '../../../../components/DialogBody';
import { DialogFooter } from '../../../../components/DialogFooter';
import { Button } from '../../../../components/Button';
import FeedbackCard from '../../../../components/FeedbackCard';

export const ConfirmationModal = ({
    header,
    body,
    confirmButtonText,
    confirmButtonProps = { appearance: 'primary', text: true },
    closeDialog,
    onConfirm
}) => {
    const [loading, setLoading] = useState('');
    const [fatalError, setFatalError] = useState(null);

    const CloseDialog = () => {
        return typeof closeDialog === 'function' ? closeDialog() : null;
    };

    const Confirm = () => {
        setLoading('loading');
        onConfirm()
            .then((resp) => {
                setLoading('success');
                setTimeout(() => {
                    setLoading('');
                    CloseDialog();
                }, 500);
            })
            .catch((e) => {
                setFatalError(e);
                setLoading('');
            });
    };

    const { disabled: propDisabled, ...restConfirmButtonProps } = confirmButtonProps;

    return (
        <div style={{ height: `30rem` }}>
            <Dialog close={CloseDialog} size="md" visible id="deploy-queue-manager-addEdit">
                <DialogHeader close={CloseDialog}>{header}</DialogHeader>
                <DialogBody>
                    {body}
                    {fatalError != null && (
                        <FeedbackCard
                            intent={'danger'}
                            feedback={{
                                heading: `An error has occurred.`,
                                message: `Please wait a few moments before trying your request
        again.`
                            }}
                            details={fatalError}
                        />
                    )}
                </DialogBody>
                <DialogFooter>
                    {loading === 'loading' && <div style={{ marginRight: '0.5rem' }}>Loading...</div>}
                    {loading === 'success' && (
                        <div style={{ marginRight: '0.5rem' }}>
                            <MaterialIcon icon={'done_outline'} color={'#04846D'} />
                        </div>
                    )}
                    <Button {...restConfirmButtonProps} onClick={Confirm} disabled={loading !== '' || propDisabled}>
                        {confirmButtonText}
                    </Button>
                    <Button appearance="secondary" text onClick={CloseDialog}>
                        Cancel
                    </Button>
                </DialogFooter>
            </Dialog>
        </div>
    );
};

ConfirmationModal.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    header: PropTypes.string.isRequired,
    body: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    confirmButtonText: PropTypes.string.isRequired,
    confirmButtonProps: PropTypes.object,
    data: PropTypes.object,
    closeDialog: PropTypes.func.isRequired
};

export default ConfirmationModal;